import ApiConstants from "../../Constants/ApiConstant";
import { apiDelete, apiGet, apiPost, apiPut } from "../../Services/ApiService";

export const getProductCategoryDetailsAPI = (params, callBack) => {
  return async () => {
    try {
      let url = ApiConstants.productCategoryUrl;
      const queryParams = [];

      if (params?.searchQuery)
        queryParams.push(`search=${encodeURIComponent(params.searchQuery)}`);
      if (params.page)
        queryParams.push(`page=${encodeURIComponent(params.page)}`);
      if (params.limit)
        queryParams.push(`limit=${encodeURIComponent(params.limit)}`);
      if (params?.milestone_id)
        queryParams.push(`milestone_id=${encodeURIComponent(params.milestone_id)}`);
      if (params?.reward_point_unit_id)
        queryParams.push(`reward_point_unit_id=${encodeURIComponent(params.reward_point_unit_id)}`);
      if (params.user_id)
        queryParams.push(`user_id=${encodeURIComponent(params.user_id)}`)
      if (params.manufacturer_id)
        queryParams.push(`manufacturer_id=${encodeURIComponent(params.manufacturer_id)}`)
      if (params.product_category_id)
        queryParams.push(`product_category_id=${encodeURIComponent(params.product_category_id)}`)

      // Append query parameters to URL if they exist
      if (queryParams?.length > 0) {
        url += `?${queryParams.join("&")}`;
      }

      await apiGet(url)
        .then((response) => {
          callBack && callBack(response, response?.data);
        })
        .catch((err) => {
          console.log("get product api err:", err);
          throw err;
        });
    } catch (err) {
      console.log("get product api err:", err);
      throw err;
    }
  };
};

export const productCategoryAssignmentAPI = (params, callBack) => {
  return async () => {
    let url = ApiConstants.productCategoryAssignmentUrl;
    const queryParams = [];
    if (params.user_id)
      queryParams.push(`user_id=${encodeURIComponent(params.user_id)}`)
    if (params.manufacturer_id)
      queryParams.push(`manufacturer_id=${encodeURIComponent(params.manufacturer_id)}`)
    if (params.product_category_id)
      queryParams.push(`product_category_id=${encodeURIComponent(params.product_category_id)}`)
    
    // Append query parameters to URL if they exist
    if (queryParams?.length > 0) {
      url += `?${queryParams.join("&")}`;
    }
    try {
      await apiGet(url)
        .then((response) => {
          callBack && callBack(response, response?.data);
        })
        .catch((err) => {
          console.log("get product category assignment api err:", err);
          throw err;
        });
    } catch (error) {
      console.log("error:", error)
      throw error
    }
  }
}
export const getProductSubCategoryNameByCategoryId = (categoryId, callBack) => {
  return async () => {
    try {
      await apiGet(
        `${ApiConstants.productCategoryUrl}?product_category_id=${categoryId}`
      )
        .then((response) => {
          callBack && callBack(response, response?.data);
        })
        .catch((err) => {
          console.log(
            "get product sub category name by category id api err:",
            err
          );
          throw err;
        });
    } catch (err) {
      console.log("get product api err:", err);
      throw err;
    }
  };
};
export const getProductCategoryByCategoryNameAPI = (categoryName, callBack) => {
  return async () => {
    try {
      await apiGet(
        `${ApiConstants.productCategoryByCategoryNameUrl}?product_category_name=${categoryName}`
      )
        .then((response) => {
          callBack && callBack(response, response?.data);
        })
        .catch((err) => {
          console.log("get product category by category name api err:", err);
          throw err;
        });
    } catch (err) {
      console.log("get product api err:", err);
      throw err;
    }
  };
};
export const getProductCategoryByCategoryIdAPI = (categoryId, callBack, manufacturerId) => {
  return async () => {
    try {
      await apiGet(
        `${ApiConstants.productCategoryByCategoryNameUrl}?product_category_id=${categoryId}`
      )
        .then((response) => {
          callBack && callBack(response, response?.data);
        })
        .catch((err) => {
          console.log("get product category by category name api err:", err);
          throw err;
        });
    } catch (err) {
      console.log("get product api err:", err);
      throw err;
    }
  };
};
export const addProductCategoryDetailsAPI = (data, callBack) => {
  return async () => {
    try {
      await apiPost(ApiConstants.productCategoryUrl, data)
        .then((response) => {
          callBack && callBack(response?.data, response?.data);
        })
        .catch((err) => {
          console.log("add product category api err===-=>>>:", err);
          throw err;
        });
    } catch (err) {
      console.log("add product category api err:", err);
      throw err;
    }
  };
};

export const updateProductCategoryDetailsAPI = (data, callBack) => {
  return async () => {
    try {
      await apiPut(ApiConstants.productCategoryUrl, data)
        .then((response) => {
          callBack && callBack(response?.data, response?.data);
        })
        .catch((err) => {
          console.log("update product category api err===-=>>>:", err);
          throw err;
        });
    } catch (err) {
      console.log("update product category api err:", err);
      throw err;
    }
  };
};

export const deleteProductCategoryDetailsAPI = (data, callBack) => {
  return async () => {
    try {
      await apiDelete(
        `${ApiConstants.productCategoryUrl}/?product_category_id=${data}`
      )
        .then((response) => {
          callBack && callBack(response?.data, response?.data);
        })
        .catch((err) => {
          console.log("delete product category api err===-=>>>:", err);
          throw err;
        });
    } catch (err) {
      console.log("delete product category api err:", err);
      throw err;
    }
  };
};

export const getSubCategoriesByCategoryName = (data, callBack) => {
  return async () => {
    try {
      await apiGet(
        `${ApiConstants.productCategoryUrl}?product_category_name=${data}`
      )
        .then((response) => {
          callBack && callBack(response);
        })
        .catch((err) => {
          console.log("get subcategories by category name api err:", err);
          throw err;
        });
    } catch (err) {
      console.log("get subcategories by category name api err:", err);
      throw err;
    }
  };
};
